// Quiz definition for Idéalab (French) — 21 questions, all QCM, 4 options max (Autre included).
export const OTHER = "Autre (écris-le ici)";

export const PHASE_LABELS = { 1: "TA SITUATION", 2: "TON PROJET", 3: "TES COMPÉTENCES" };

export const QUESTIONS = [
  // ---- PHASE 1 — TA SITUATION ----
  { id: "q1", phase: 1, type: "choice", question: "Tu as quel âge ?",
    options: ["16-20 ans", "21-25 ans", "26-35 ans", "36 ans et +"] },
  { id: "q2", phase: 1, type: "choice", question: "Depuis combien de temps tu cherches à te lancer dans un business ?",
    options: ["Je commence à peine", "Quelques mois", "Plus d'un an", "Plusieurs années"] },
  { id: "q3", phase: 1, type: "choice", question: "Quels sont tes revenus mensuels ?",
    options: ["0 €", "Moins de 1 000 €", "1 000 à 2 000 €", "Plus de 2 000 €"] },
  { id: "q4", phase: 1, type: "choice", question: "Tu postes sur des plateformes ?",
    options: ["Jamais", "De temps en temps", "Régulièrement", "J'ai déjà une audience"] },
  { id: "q5", phase: 1, type: "choice", question: "T'as déjà testé des business ?",
    options: ["Jamais", "Une fois", "Plusieurs fois", "Oui, et j'ai déjà gagné de l'argent"] },

  // ---- PHASE 2 — TON PROJET ----
  { id: "q6", phase: 2, type: "choice", hasOther: true, question: "Tu te vois plutôt avec un business :",
    options: ["En ligne", "Physique", "Les deux"] },
  { id: "q7", phase: 2, type: "choice", question: "Quel est ton rêve ultime ?",
    options: ["Être libre financièrement", "Rendre mes parents fiers", "Quitter mon travail", "Faire mes premiers 1 000 €"] },
  { id: "q8", phase: 2, type: "choice", hasOther: true, question: "Qu'est-ce qui t'empêche d'atteindre ce rêve ?",
    options: ["Le manque de méthode", "J'ai du mal à me concentrer", "Je viens de commencer"] },
  { id: "q9", phase: 2, type: "scale", question: "Je suis du genre à continuer même si c'est difficile",
    options: ["Pas du tout", "Non", "Je sais pas", "Oui complètement"] },
  { id: "q10", phase: 2, type: "choice", question: "Tu peux y consacrer combien d'heures par semaine ?",
    options: ["Moins de 5h", "5-10h", "10-20h", "20h et +"] },

  // ---- PHASE 3 — TES COMPÉTENCES ----
  { id: "q11", phase: 3, type: "multi", hasOther: true, question: "Qu'est-ce que tu sais déjà faire ?",
    options: ["Créer du contenu (réseaux, vidéo, photo, design)", "Travailler de mes mains (bricolage, cuisine, beauté)", "Vendre, conseiller, expliquer"] },
  { id: "q12", phase: 3, type: "choice", hasOther: true, dynamicFrom: "q11", question: "Parmi tout ça, quelle est ta plus grande force ?", options: [] },
  { id: "q13", phase: 3, type: "multi", hasOther: true, question: "Pour quoi les gens te demandent souvent de l'aide ?",
    options: ["Mon style, mon image", "La tech, les téléphones, les ordis", "Les réseaux sociaux, les photos, les vidéos"] },
  { id: "q14", phase: 3, type: "multi", hasOther: true, question: "Quel sujet pourrais-tu expliquer pendant des heures ?",
    options: ["Mode, beauté, style de vie", "Sport, santé, alimentation", "Argent, business, tech"] },
  { id: "q15", phase: 3, type: "choice", hasOther: true, question: "Te montrer face caméra :",
    options: ["Aucun problème", "OK si nécessaire", "Jamais"] },
  { id: "q16", phase: 3, type: "choice", hasOther: true, question: "Parler à des inconnus pour vendre :",
    options: ["J'adore", "Je peux le faire", "Je déteste"] },
  { id: "q17", phase: 3, type: "multi", hasOther: true, question: "Ce que tu refuses de faire :",
    options: ["Gérer du stock", "Démarcher par téléphone", "Montrer mon visage"] },
  { id: "q18", phase: 3, type: "multi", hasOther: true, question: "Ce que tu as à disposition :",
    options: ["Ordinateur", "Smartphone uniquement", "Voiture ou permis"] },
  { id: "q19", phase: 3, type: "choice", hasOther: true, question: "Tu peux investir combien au départ ?",
    options: ["0 €", "50 € dans mes outils", "100 €"] },
  { id: "q20", phase: 3, type: "choice", hasOther: true, question: "Tu vis où ?",
    options: ["Belgique", "France", "Suisse"] },
  { id: "q21", phase: 3, type: "slider", question: "Tu souhaiterais gagner combien dans 3 mois ?",
    min: 100, max: 40000, step: 100 },
];

// Options for the dynamic Q12 (built from Q11 selections), max 4 (incl. Autre added in UI).
export function q12Options(answers) {
  const arr = answers.q11 || [];
  const opts = arr.filter((x) => x !== OTHER);
  const otherTxt = (answers.q11_other || "").trim();
  if (arr.includes(OTHER) && otherTxt) opts.push(otherTxt);
  return opts.slice(0, 3);
}

// Skip Q12 when Q11 has only one selected option (nothing to compare).
export function shouldSkipQ12(answers) {
  return q12Options(answers).length <= 1;
}

// Build clean answers to send to the LLM: replace "Autre" tokens with typed text.
export function buildAnswersForApi(answers) {
  const out = {};
  QUESTIONS.forEach((q) => {
    const v = answers[q.id];
    if (v === undefined || v === null) return;
    const otherTxt = (answers[q.id + "_other"] || "").trim();
    if (Array.isArray(v)) {
      const arr = v
        .map((x) => (x === OTHER ? otherTxt : x))
        .filter((x) => x && String(x).trim());
      if (arr.length) out[q.id] = arr;
    } else if (v === OTHER) {
      if (otherTxt) out[q.id] = otherTxt;
    } else {
      out[q.id] = v;
    }
  });
  return out;
}

// Warm, short reassurance shown under each selected answer (max 12 words, tutoiement).
export const REASSURANCE = {
  q1: {
    "16-20 ans": "Tu t'y prends tôt, c'est un vrai avantage.",
    "21-25 ans": "Le meilleur âge pour tester sans pression.",
    "26-35 ans": "Tu as l'expérience et l'énergie qu'il faut.",
    "36 ans et +": "Ta maturité est un atout, jamais un frein.",
  },
  q2: {
    "Je commence à peine": "Parfait, on part sur des bases saines ensemble.",
    "Quelques mois": "Tu es déjà en mouvement, c'est l'essentiel.",
    "Plus d'un an": "Cette fois, tu vas avoir un vrai plan.",
    "Plusieurs années": "Ton déclic, c'est maintenant. On s'en occupe.",
  },
  q3: {
    "0 €": "Aucun souci, beaucoup démarrent exactement d'ici.",
    "Moins de 1 000 €": "C'est un point de départ tout à fait normal.",
    "1 000 à 2 000 €": "Une base stable pour te lancer sereinement.",
    "Plus de 2 000 €": "Tu as de quoi avancer en confiance.",
  },
  q4: {
    "Jamais": "Aucun problème, ton plan ne l'exige pas.",
    "De temps en temps": "C'est déjà une bonne habitude à exploiter.",
    "Régulièrement": "Super, tu as déjà le réflexe du contenu.",
    "J'ai déjà une audience": "Excellent, on va la transformer en revenus.",
  },
  q5: {
    "Jamais": "Aucune expérience requise, ton plan part de zéro.",
    "Une fois": "Chaque essai t'a appris quelque chose d'utile.",
    "Plusieurs fois": "Ton expérience va accélérer les choses.",
    "Oui, et j'ai déjà gagné de l'argent": "Génial, tu sais déjà que c'est possible.",
  },
  q6: {
    "En ligne": "Idéal pour démarrer léger, sans gros budget.",
    "Physique": "Un business concret, proche de chez toi.",
    "Les deux": "On combinera le meilleur des deux mondes.",
    __other: "Note ton idée, on l'intègre à ton plan.",
  },
  q7: {
    "Être libre financièrement": "Un cap clair, on trace le chemin ensemble.",
    "Rendre mes parents fiers": "Belle motivation, elle va te porter loin.",
    "Quitter mon travail": "On construit ta sortie, étape par étape.",
    "Faire mes premiers 1 000 €": "Objectif net et totalement atteignable.",
  },
  q8: {
    "Le manque de méthode": "C'est exactement ce qu'on va te donner.",
    "J'ai du mal à me concentrer": "Ton plan avance en petites étapes simples.",
    "Je viens de commencer": "Le bon moment pour de bonnes bases.",
    __other: "Merci, on en tient compte dans ton plan.",
  },
  q9: {
    "Pas du tout": "On rendra les étapes faciles à tenir.",
    "Non": "Pas grave, ton plan restera simple et guidé.",
    "Je sais pas": "On avancera à ton rythme, sans pression.",
    "Oui complètement": "Cette ténacité fera toute la différence.",
  },
  q10: {
    "Moins de 5h": "Peu de temps suffit pour bien démarrer.",
    "5-10h": "Un rythme parfait pour progresser régulièrement.",
    "10-20h": "Tu vas pouvoir avancer vraiment vite.",
    "20h et +": "Avec ça, les résultats arrivent rapidement.",
  },
  q11: {
    "Créer du contenu (réseaux, vidéo, photo, design)": "Une compétence très recherchée aujourd'hui.",
    "Travailler de mes mains (bricolage, cuisine, beauté)": "Un savoir-faire concret qui se monétise bien.",
    "Vendre, conseiller, expliquer": "La compétence n°1 pour gagner de l'argent.",
    __other: "Parfait, on s'appuiera dessus dans ton plan.",
  },
  q13: {
    "Mon style, mon image": "Ton sens de l'esthétique est un vrai atout.",
    "La tech, les téléphones, les ordis": "Des compétences très demandées et bien payées.",
    "Les réseaux sociaux, les photos, les vidéos": "Parfait pour créer et vendre en ligne.",
    __other: "Bien noté, on l'ajoute à ton profil.",
  },
  q14: {
    "Mode, beauté, style de vie": "Un univers porteur avec un large public.",
    "Sport, santé, alimentation": "Des thèmes qui passionnent énormément de monde.",
    "Argent, business, tech": "Des sujets où les gens paient pour apprendre.",
    __other: "Top, on part de ce que tu aimes.",
  },
  q15: {
    "Aucun problème": "Un vrai plus pour créer du lien vite.",
    "OK si nécessaire": "Parfait, on l'utilisera juste quand ça aide.",
    "Jamais": "Aucun souci, ton plan marche sans caméra.",
    __other: "Compris, on adapte ton plan en conséquence.",
  },
  q16: {
    "J'adore": "Cette aisance va booster tes premières ventes.",
    "Je peux le faire": "C'est déjà suffisant pour bien démarrer.",
    "Je déteste": "Pas de souci, on privilégiera d'autres canaux.",
    __other: "Noté, on choisira l'approche qui te convient.",
  },
  q17: {
    "Gérer du stock": "Parfait, on évitera tout ce qui pèse.",
    "Démarcher par téléphone": "Compris, ton plan s'en passera totalement.",
    "Montrer mon visage": "Aucun souci, on reste dans ta zone de confort.",
    __other: "Bien reçu, on respecte tes limites.",
  },
  q18: {
    "Ordinateur": "Idéal, tu as tout pour travailler efficacement.",
    "Smartphone uniquement": "Bonne nouvelle : c'est largement suffisant pour démarrer.",
    "Voiture ou permis": "Ça ouvre des options près de chez toi.",
    __other: "Parfait, on tient compte de tes moyens.",
  },
  q19: {
    "0 €": "Aucun souci, ton plan démarre sans rien dépenser.",
    "50 € dans mes outils": "Parfait, on investit chaque euro intelligemment.",
    "100 €": "Un petit budget qui accélère bien les choses.",
    __other: "Bien noté, on cale ton plan sur ce budget.",
  },
  q20: {
    "Belgique": "On adaptera ton plan au marché belge.",
    "France": "Ton plan sera calé sur le marché français.",
    "Suisse": "On ajustera ton plan au marché suisse.",
    __other: "Note ton pays, on adapte ton plan.",
  },
};

// Returns the reassurance line for a given question/answer, or null.
export function reassuranceFor(q, opt) {
  if (!q) return null;
  if (q.id === "q12") return "Super, on bâtira ton business autour de ça.";
  if (q.id === "q21") return "Objectif clair et réaliste, on te trace le chemin.";
  const m = REASSURANCE[q.id];
  if (!m) return null;
  if (opt === OTHER) return m.__other || null;
  return m[opt] || null;
}

export function computeDiagnostic(answers) {
  const q2 = (answers.q2 || "").toLowerCase();
  const q4 = (answers.q4 || "").toLowerCase();
  const q5 = (answers.q5 || "").toLowerCase();

  const cherchesLongtemps = q2.includes("plus d'un an") || q2.includes("plusieurs anné");
  const testePlusieurs = q5.includes("plusieurs fois") || q5.includes("gagné");
  const jamaisTeste = q5.includes("jamais");
  const commenceAPeine = q2.includes("commence à peine");
  const posteRegulier = q4.includes("réguli") || q4.includes("audience");

  if (cherchesLongtemps && testePlusieurs) return "Il te manque la méthode";
  if (jamaisTeste && commenceAPeine) return "Il te manque un plan clair pour démarrer";
  if (posteRegulier) return "Il te manque le bon business pour monétiser ton audience";
  return "Il te manque la méthode";
}
